import { z } from 'zod';

export const adminInvitationSearchSchema = z.object({
  organizationId: z.string().trim().min(1).optional().catch(undefined),
  q: z.string().trim().min(1).optional().catch(undefined),
  status: z.enum(['pending', 'expired', 'accepted', 'cancelled']).optional().catch(undefined),
});

export function normalizeAdminInvitationQuery(value: string | null | undefined) {
  return value?.trim() || undefined;
}
